import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setModalPaymentTicketSuccess } from "@/app/modal/actions";
 
import "./styles.scss";
import { FaCheckCircle } from "react-icons/fa";
const ModalPaymentTicketSuccess = () => {
  const dispatch = useDispatch();
  const { modalPaymentTicketSuccess } = useSelector(
    (state: any) => state.modal
  );
  
  // Get tickets from modal data or use mock data
  const tickets = modalPaymentTicketSuccess?.data?.tickets || [
    {round: "LD-001", code: "12345"},
    {round: "LD-002", code: "12345"},
    {round: "LD-003", code: "12345"},
    {round: "LD-004", code: "12345"},
    {round: "LD-005", code: "12345"},
  ];
  
  const totalAmount = modalPaymentTicketSuccess?.data?.totalAmount || 20;
  const handleCancel = () => {
    dispatch(
      setModalPaymentTicketSuccess({
        toggle: false,
        data: {},
      })
    );
  };

  const onClose = () => {
    dispatch(
      setModalPaymentTicketSuccess({
        toggle: false,
        data: {},
      })
    );
  };
  const quantity = tickets.length;

  return (
    <Modal
      title="Payment Successful!"
      visible={modalPaymentTicketSuccess?.toggle}
      onCancel={handleCancel}
      footer={false}
      width={400}
      className="modal-buy-ticket"
      centered
      style={{ top: 20 }}
    >
      <div className="modal-payment-success pt-4 flex flex-col justify-center items-center gap-6">
        <div className="status flex flex-col justify-center items-center gap-1">
          <FaCheckCircle size={98} color="#2BDC31" />
          <h3 className="text-xl font-bold">You're all set</h3>
          <span className="text-xs text-[#2750FB]">Amount paid: {totalAmount} MBC</span>
        </div>

        <div className="tickets flex flex-col items-center gap-4 w-full">
          <span className="title text-md font-bold uppercase">
            Your Tickets: <span className="text-[#2750FB]">{quantity}</span>
          </span>
          <div className="ticket-grid w-full">
            {tickets && tickets.length > 0 && (
              tickets.map((ticket, index) => (
                <div key={`${ticket.id || index}`} className="ticket-card flex flex-col items-center gap-2 p-[10px] rounded-[10px] border border-[#73A3E6]">
                  <span className="ticket-round text-xs text-[#000] font-bold">
                    LD-{String(ticket.round?.roundNumber || ticket.roundNumber || index + 1).padStart(3, '0')}
                  </span>
                  <span className="ticket-code text-sm text-[#fff] font-bold rounded-[6px] p-[6px]">
                    {ticket.ticketNumber || `#${index + 1}`}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="actions text-center mt-2 w-full">
          <button
            onClick={onClose}
            className="w-full h-11 bg-[#2750FB] text-white border-none rounded-md text-base font-bold cursor-pointer mb-2 uppercase tracking-wider"
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalPaymentTicketSuccess;
